import { FunnelSimpleIcon, HandPointingIcon, LightningIcon } from '@phosphor-icons/react'
import type { ListKindName } from 'app/types/list-kind'

/** How a list gets its members, said the same way on its page and on the New list cards. */
export const LIST_KINDS = {
  filter: { Icon: FunnelSimpleIcon, label: `Filter list`, blurb: `Updates itself from a saved filter.` },
  manual: { Icon: HandPointingIcon, label: `Manual list`, blurb: `You add people and move them through stages.` },
  builtIn: {
    Icon: LightningIcon,
    label: `Smart list`,
    blurb: `Trackable finds these people for you from your practice's data.`,
  },
} as const satisfies Readonly<Record<ListKindName, object>>
